<div id="delete-confirm-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{'DASHBOARD.FAVORITE.RESET' | translate}}
        </span>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="dialog-container">
      <div class="dialog-content-wrapper">
        <div class="title-content">
          {{'DASHBOARD.RESET.CONFIRMATION' | translate}}
        </div>
        <div class="confirmation">
          {{'DASHBOARD.RESET.CONFIRMATION2' | translate}}
        </div>
        <div mat-dialog-actions class="btn-container">
          <button
            mat-raised-button
            class="mat-warn button-confirm"
            (click)="matDialogRef.close(true)">
            {{'GENERAL.CONFIRM' | translate}}
          </button>
          <button mat-button (click)="matDialogRef.close(false)">
            {{'GENERAL.CANCEL' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
